import { request } from './client';

// Splitting the prize is a deal between the last two players standing. Either can
// offer; only the other one can answer. Accepting ends the game there and then as
// a shared win, so the whole flow is scoped to a single game.

/**
 * Whether an offer can be made right now. False for a game that is not down to
 * exactly two, and false once an offer has already been made this game week -
 * the server owns that rule, so ask rather than infer it.
 */
export function canRequestSplit(gameId) {
  return request(`/api/games/${gameId}/split-prize/can-request`);
}

/** Offer a split to the other remaining player. */
export function requestSplit(gameId) {
  return request(`/api/games/${gameId}/split-prize/request`, { method: 'POST' });
}

/** Accept an offer made to you. Ends the game as a shared win - there is no undo. */
export function acceptSplit(gameId, requestId) {
  return request(`/api/games/${gameId}/split-prize/requests/${requestId}/accept`, {
    method: 'PUT',
  });
}

/** Turn down an offer made to you. The game carries on. */
export function rejectSplit(gameId, requestId) {
  return request(`/api/games/${gameId}/split-prize/requests/${requestId}/reject`, {
    method: 'PUT',
  });
}

/**
 * Every offer this game has seen, answered or not.
 *
 * Preferred over the /pending endpoint, which 404s when nothing is outstanding -
 * that would be an ApiError to swallow on the most ordinary state of all. The
 * pending one, if any, is the row with status PENDING.
 */
export function getSplitRequests(gameId) {
  return request(`/api/games/${gameId}/split-prize/requests`);
}
